import React, { useEffect } from 'react'
import BoutonRetourHome from './sub-components/BoutonRetourHome';
import TagManager from 'react-gtm-module';
import { ExternalLayout } from './Layout/ExternalLayout';
import { Container } from 'reactstrap';
import { FooterLinks } from './Layout/FooterLinks';
import { ProgressBar } from './ProgressBar';

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
    dataLayerName: 'PageDataLayer'
}

TagManager.initialize(tagManagerArgs)

const Merci = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const uploadError = urlParams.has('uploadError');

    useEffect(() => {
        // Récupération des données candidat stockées avant la redirection
        const gtmData = sessionStorage.getItem('gtm_inscription');
        if (gtmData) {
            const payload = JSON.parse(gtmData);

            // Vérification du consentement analytics via le cookie Axeptio
            let consentementAccorde = false;
            const axeptioCookie = document.cookie
                .split('; ')
                .find(row => row.startsWith('axeptio_cookies='));
            if (axeptioCookie) {
                try {
                    const axeptioValue = JSON.parse(decodeURIComponent(axeptioCookie.split('=')[1]));
                    consentementAccorde = axeptioValue.google_analytics === true;
                } catch (e) {
                    console.warn('Impossible de lire le cookie Axeptio', e);
                }
            }
            console.log("gtm", gtmData);
            console.log("Consentement Google :", consentementAccorde);
            if (!consentementAccorde) {
                delete payload.candidat_nom;
                delete payload.candidat_prenom;
                delete payload.candidat_mail;
                delete payload.candidat_telephone;
            }

            TagManager.dataLayer({ dataLayer: payload, dataLayerName: 'PageDataLayer' });

            // Nettoyage pour éviter un double push si l'utilisateur rafraîchit la page
            sessionStorage.removeItem('gtm_inscription');
        }
    }, []);

    return (
        <div>
            <ExternalLayout />
            <Container className='px-0'>
                <ProgressBar step={3} maxStep={3} />
                <div className="border-outline-eni d-block w-100 color-blue-dark-eni openSans py-4">
                    <div className="text-center px-3">
                        <h1 className="fs-16 fw-bold mb-4">
                            Nous vous remercions pour votre candidature qui a été enregistrée avec succès !
                        </h1>
                        <p>
                            Elle est actuellement à l'étude par nos équipes. Nous reviendrons vers vous prochainement
                            afin de vous tenir informé des prochaines étapes du processus de sélection.
                        </p>
                        {uploadError && (
                            <div className="alert alert-warning mt-3">
                                Cependant, l'envoi de vos documents a échoué. Vous pourrez les renvoyer par mail
                                suite à la confirmation d'inscription que vous allez recevoir.
                            </div>
                        )}
                        <p>
                            Si vous n'avez pas encore transmis votre CV lors de votre inscription, nous vous invitons
                            à l'envoyer à l'adresse suivante : <strong>postuler@eni-ecole.fr</strong>.
                        </p>
                        <p>
                            A bientôt,<br />
                            Le service admission ENI Ecole Informatique
                        </p>
                    </div>
                </div>
                <BoutonRetourHome />
            </Container>
            <FooterLinks/>
        </div>
    );
}

export default Merci
